import * as React from 'react';


const MobileFormFieldWrapper = (props) => {

  return (
    <div className="input__cont --withvalue">
      <span className="input__lbl">
        {props.label}
      </span>
      {props.children}
      {!props.noPriceView && 
        <div className="input--sign__sign">
          {`$${props.price}`}
        </div>
      }
    </div>
  );
};

export default MobileFormFieldWrapper;
